<div class="fill-parent">

    <div class="fill-parent" *ngIf="isout" >
      <div *ngIf="nodata">
        <label>No data in the selected period.</label>
      </div>
      <div *ngFor="let element of reportdata.slice(0, 4)" style="width: 400px; height: 50px;">
        <div>
          <div>
            <ngx-charts-line-chart
            [view]="view"
            [results]="element.chart"
            [yScaleMin] = 0
            [yScaleMax] = 100
            [showGridLines]="false">
            <ng-template #tooltipTemplate let-model="model">
              <div class="tt">
                utilization: {{ model.value }}%
              </div>
            </ng-template>

            <ng-template #seriesTooltipTemplate let-model="model">
              <div class="tt">
                utilization: {{ model[0].value }}%
              </div>
            </ng-template>
           </ngx-charts-line-chart>
          </div>
          <div>
            <label style="margin-top: 17px;">{{ (element.schoolName.length > 20) ? (element.schoolName | slice:0:20)+'...' : element.schoolName }}</label>
          </div>


        </div>
      </div>
    </div>


    <div class="report-head" *ngIf="!isout">
      <div class="report-back">
  <button class="main-btn empty-back-btn" (click)="navigateBack()"><img src="/assets/images/back.svg" />Chart Dashboard</button></div>
      <div class="report-title detail-page-title margin-l-l">
        Utilization Across Sites
      </div>
      <div class="report-date">
        <mat-form-field (click)="picker.open()"  class="report-picker" appearance="outline">
          <input matInput [matDatepicker]="picker" [(ngModel)]="startDate" placeholder="Start Date">
          <mat-datepicker-toggle class="picker-icon" matPrefix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker (closed)="onSelectDate()"  #picker></mat-datepicker>
        </mat-form-field>

        <mat-form-field (click)="picker2.open()"  class="report-picker" appearance="outline">
          <input matInput [matDatepicker]="picker2" [(ngModel)]="endDate" placeholder="Start Date">
          <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker (closed)="onSelectDate()"  #picker2></mat-datepicker>
        </mat-form-field>
        <!--<mat-datepicker-toggle  matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-input  [rangePicker]="picker">
          <input matStartDate [(ngModel)]="startDate" placeholder="Start date">
          <input matEndDate [(ngModel)]="endDate" placeholder="End date">
        </mat-date-input>
        <mat-date-range-picker (closed)="onSelectDate()" #picker></mat-date-range-picker>!-->
      </div>
    </div>
    <div class="flex-grow-1 display-flex flex-col" *ngIf="!isout">
      <table mat-table matSort (matSortChange)="schoolsSortChange($event)" [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="chart">
          <th mat-header-cell *matHeaderCellDef>  Device Utilization(%) </th>
          <td mat-cell *matCellDef="let element">

              <ngx-charts-line-chart
                [view]="view"
                [results]="element.chart"
                [yScaleMin] = 0
                [yScaleMax] = 100
                [showGridLines]="false">
                <ng-template #tooltipTemplate let-model="model">
                  <div class="tt">
                    utilization: {{ model.value }}%
                  </div>
                </ng-template>

                <ng-template #seriesTooltipTemplate let-model="model">
                  <div class="tt">
                    utilization: {{ model[0].value }}%
                  </div>
                </ng-template>
              </ngx-charts-line-chart>
        </ng-container>

        <ng-container matColumnDef="schoolName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by schoolName"> Site Name </th>
          <td mat-cell *matCellDef="let element"> {{element.schoolName}} </td>
        </ng-container>

        <ng-container matColumnDef="lastSync">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by lastSync"> Latest Sync </th>
          <td mat-cell *matCellDef="let element"> {{element.latestSyncUpdate}} </td>
        </ng-container>

        <ng-container matColumnDef="activeDevices">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by activeDevices"> Device synched </th>
          <td mat-cell *matCellDef="let element"> {{element.activeDevices}} </td>
        </ng-container>

        <ng-container matColumnDef="totalDevies">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by totalDevices"> Total devices </th>
          <td mat-cell *matCellDef="let element"> {{element.totalDevices}} </td>
        </ng-container>

        <ng-container matColumnDef="schoolType">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by schoolType"> Site Type </th>
          <td mat-cell *matCellDef="let element"> {{element.schoolType}} </td>
        </ng-container>

        <ng-container matColumnDef="level1">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by level1"> Geo 1 </th>
          <td mat-cell *matCellDef="let element"> {{element.level1}} </td>
        </ng-container>

        <ng-container matColumnDef="level2">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by level2"> Geo 2 </th>
          <td mat-cell *matCellDef="let element"> {{element.level2}} </td>
        </ng-container>
        <ng-container matColumnDef="level3">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by level3"> Geo 3 </th>
          <td mat-cell *matCellDef="let element"> {{element.level3}} </td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"  (dblclick)="navigateTo(row)"></tr>

      </table>
      <mat-paginator [pageSizeOptions]="[5, 10, 20]"
      showFirstLastButtons aria-label="Select page of periodic elements"></mat-paginator>
      </div>

  </div>
